import type { Theme } from "./options";
import { prefersDark } from "./support";

export type ThemeInput = { theme: Theme; darkBaseMap: boolean };

export function effectiveDark(input: ThemeInput): boolean {
  if (input.theme === "dark") return true;
  if (input.theme === "light") return false;

  return input.darkBaseMap || prefersDark();
}

export function applyTheme(container: HTMLElement, input: ThemeInput): boolean {
  const dark = effectiveDark(input);

  container.classList.toggle("fxmap-dark", dark);

  return dark;
}

export function watchSystemTheme(onChange: () => void): () => void {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return () => undefined;

  const query = window.matchMedia("(prefers-color-scheme: dark)");
  const listener = () => onChange();

  if (typeof query.addEventListener === "function") {
    query.addEventListener("change", listener);

    return () => query.removeEventListener("change", listener);
  }

  return () => undefined;
}
